.screen {
	min-height: 100%;
	padding: var(--space-5);
	max-width: var(--screen-max);
	margin: 0 auto;
	display: grid;
	place-content: center;
	place-items: center;
	gap: var(--space-3);
	text-align: center;
}

.emoji {
	font-size: 4rem;
}

.title {
	margin: 0;
	font-size: 2rem;
	font-weight: 600;
}

.hint {
	margin: 0;
	max-width: 28ch;
	color: var(--ink-muted);
}

.reload {
	margin-top: var(--space-3);
	padding: var(--space-2) var(--space-5);
	border: none;
	border-radius: var(--radius-md);
	background: var(--accent-sage);
	color: #fff;
	font-size: 1rem;
	font-weight: 600;
	cursor: pointer;
}

.reload:hover {
	filter: brightness(1.05);
}
